import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  position: relative;

  .splide__track {
    padding: 20px 0;
    margin: -20px 0;
  }
`
